var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 78,
    viewBox: "0 0 88 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6091 2.50014L87.3008 71.2501C87.6665 71.8836 87.859 72.6021 87.859 73.3335C87.859 74.0648 87.6665 74.7834 87.3008 75.4168C86.9351 76.0502 86.4092 76.5762 85.7758 76.9419C85.1424 77.3076 84.4239 77.5001 83.6925 77.5001H4.30914C3.57774 77.5001 2.85924 77.3076 2.22584 76.9419C1.59244 76.5762 1.06647 76.0502 0.700779 75.4168C0.33509 74.7834 0.142573 74.0648 0.142578 73.3335C0.142583 72.6021 0.335109 71.8836 0.700806 71.2501L40.3925 2.50014C40.7582 1.86678 41.2842 1.34083 41.9176 0.975166C42.551 0.609499 43.2694 0.416992 44.0008 0.416992C44.7322 0.416992 45.4507 0.609499 46.084 0.975166C46.7174 1.34083 47.2434 1.86678 47.6091 2.50014ZM39.8341 56.6668V65.0001H48.1675V56.6668H39.8341ZM39.8341 27.5001V48.3335H48.1675V27.5001H39.8341Z",
    fill: "#F04646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.4f461e303eb704e393aa9da9eb6a8116.svg";
export { ForwardRef as ReactComponent };